import LearnitTagListResultModelBase from '../_generated/modelBases/learnit-tag-list-result-model-base';

export default class LearnitTagListResultModel extends LearnitTagListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
